import { Record as ImmutableRecord } from 'immutable'
import { TasksAction, TasksActions, TaskValue } from 'lib/actions/task'
import { initialDeleteReturn, initialGetReturn, initialListReturn, Status } from 'lib/rpc'
import { App } from 'pbts/c1/api/app/v1/app'
import { TaskSearchCountResponse, TaskSearchGetProgressResponse } from 'pbts/c1/api/task/v1/search'

export class TaskState extends ImmutableRecord({
    list: initialListReturn<TaskValue>(),
    searchCount: initialGetReturn<TaskSearchCountResponse>(),
    item: initialGetReturn<TaskValue>(),
    deleted: initialDeleteReturn(),
    reassign: initialGetReturn<TaskValue>(),
    restart: initialGetReturn<TaskValue>(),
    escalateToEmergencyAccess: initialGetReturn<TaskValue>(),
    approve: initialGetReturn<TaskValue>(),
    provisionComplete: initialGetReturn<TaskValue>(),
    provisionErrored: initialGetReturn<TaskValue>(),
    deny: initialGetReturn<TaskValue>(),
    comment: initialGetReturn<TaskValue>(),
    searchForApps: initialGetReturn<App[]>(),
    progress: initialGetReturn<TaskSearchGetProgressResponse>(),
}) { }

export const initialTaskState: TaskState = new TaskState()

export const taskReducer = (state: TaskState, action: TasksActions): TaskState => {
    switch (action.type) {
        case TasksAction.create:
            return state.set('item', action.payload)
        case TasksAction.createRevokeTask:
            return state.set('item', action.payload)
        case TasksAction.createGrantTask:
            return state.set('item', action.payload)
        case TasksAction.list:
            return state.set('list', action.payload)
        case TasksAction.searchCount:
            return state.set('searchCount', action.payload)
        case TasksAction.close:
            return state.set('item', action.payload)
        case TasksAction.delete:
            return state.set('deleted', action.payload)
        case TasksAction.reassign:
            if (action.payload.status === Status.OK) {
                state = state.set('item', action.payload)
            }

            return state.set('reassign', action.payload)
        case TasksAction.restart:
            if (action.payload.status === Status.OK) {
                state = state.set('item', action.payload)
            }

            return state.set('restart', action.payload)
        case TasksAction.escalateToEmergencyAccess:
            if (action.payload.status === Status.OK) {
                state = state.set('item', action.payload)
            }
            return state.set('escalateToEmergencyAccess', action.payload)
        case TasksAction.approve:
            if (action.payload.status === Status.OK) {
                state = state.set('item', action.payload)
            }

            return state.set('approve', action.payload)
        case TasksAction.deny:
            if (action.payload.status === Status.OK) {
                state = state.set('item', action.payload)
            }

            return state.set('deny', action.payload)
        case TasksAction.comment:
            if (action.payload.status === Status.OK) {
                state = state.set('item', action.payload)
            }

            return state.set('comment', action.payload)
        case TasksAction.searchForApps:
            return state.set('searchForApps', action.payload)
        case TasksAction.provisionComplete:
            return state.set('provisionComplete', action.payload)
        case TasksAction.provisionErrored:
            return state.set('provisionErrored', action.payload)
        case TasksAction.getProgress:
            return state.set('progress', action.payload)
        default:
            return state
    }
}
